import { Activity, Flame, TrendingDown, TrendingUp, Zap } from 'lucide-react';
import { Badge } from '@/components/ui';

interface BuzzBadgeProps {
  score: number | null;
  size?: 'sm' | 'md' | 'lg';
}

// Five tiers — colour PLUS icon, per ADR-015 (colour-blind safe).
function tierFor(score: number): { variant: 'light' | 'filled'; colour: string; icon: typeof Flame } {
  if (score >= 80) return { variant: 'filled', colour: 'red', icon: Flame };
  if (score >= 60) return { variant: 'light', colour: 'orange', icon: Zap };
  if (score >= 40) return { variant: 'light', colour: 'yellow', icon: TrendingUp };
  if (score >= 20) return { variant: 'light', colour: 'gray', icon: Activity };
  return { variant: 'light', colour: 'gray', icon: TrendingDown };
}

export function BuzzBadge({ score, size = 'md' }: BuzzBadgeProps) {
  if (score === null) {
    return (
      <Badge variant="default" size={size} color="gray" aria-label="No buzz score yet">
        —
      </Badge>
    );
  }
  const { variant, colour, icon: Icon } = tierFor(score);
  return (
    <Badge
      variant={variant}
      color={colour}
      size={size}
      leftSection={<Icon size={12} aria-hidden />}
      aria-label={`Buzz Score ${score}`}
    >
      {score}
    </Badge>
  );
}
